export const rolPath = {
  WEBSITE: "WEBSITE",
  DEVELOPER: "DEVELOPER",
};
